<template>
  <a-drawer
    :title="`选择区域(${ereaList.length})`"
    placement="right"
    :visible="visible"
    width="480px"
    class="station-drawer"
    :mask-closable="false"
    @close="onClose"
  >
    <div
      v-for="(item, index) in ereaList"
      :key="index"
      @mouseenter="onEreaEnter(index)"
      @mouseleave="onEreaLeave(index)"
    >
      <block-title
        :title="`区域${index+1}`"
        class="block"
        :show-line="false"
      >
        <span
          v-if="deleteIcon[index]"
          slot="icon-right"
          class="delete-icon"
        >
          <i
            class="iconfont icon-icon_lajitong_16x16"
            @click="onDelete(index)"
          />
        </span>
        <a-timeline class="erea-container">
          <a-timeline-item>
            <p class="erea-title">起始地区</p>
            <el-cascader
              :ref="`startArea${index}`"
              v-model="item.startArea"
              :options="ereaOptions"
              style="width: 100%"
              collapse-tags
              clearable
              size="small"
              :props="cascaderProps"
              placeholder="所有"
              @change="onChangeErea('startArea', index)"
            />
          </a-timeline-item>
          <a-timeline-item>
            <p class="erea-title">终止地区</p>
            <el-cascader
              :ref="`endArea${index}`"
              v-model="item.endArea"
              :options="ereaOptions"
              style="width: 100%"
              collapse-tags
              clearable
              size="small"
              :props="cascaderProps"
              placeholder="所有"
              @change="onChangeErea('endArea', index)"
            />
          </a-timeline-item>
        </a-timeline>
      </block-title>
    </div>
    <div v-if="ereaList.length < 5" class="add-btn">
      <a-button
        block
        type="link"
        @click="addErea"
      >
        <a-icon type="plus"/>
        添加区域
      </a-button>
    </div>
    <div
      class="drawer-bottom"
    >
      <a-button :style="{ marginRight: '12px' }" @click="onClose">
        取消
      </a-button>
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import { getCityAreaTree } from "@/components/app-cascader-province/api.js";

export default {
  name: 'StationDrawer',
  components: {
    BlockTitle,
  },
  data() {
    return {
      visible: false,
      ereaOptions: [],
      value: null,
      cascaderProps: {
        multiple: true,
        label: 'areaName',
        value: 'areaCode',
        children: 'children'
      },
      ereaList: [],
      deleteIcon: [],
    }
  },
  created() {
    this.getEreaOptions()
  },
  methods: {
    onEreaEnter(index) {
      this.$set(this.deleteIcon, index, true)
    },
    onEreaLeave(index) {
      this.$set(this.deleteIcon, index, false)
    },
    async getEreaOptions() {
      const options = await getCityAreaTree({
        filterBlackList: true,
      });
      this.ereaOptions = this.filterData(options);
    },
    filterData(list) {
      const treeList = []
      list.forEach(item => {
        let children
        if (item.children && item.children.length) {
          children = this.filterData(item.children)
        }
        treeList.push({
          ...item,
          children
        })
      })
      return treeList
    },
    show(ereaList) {
      this.visible = true
      // 没有区域时默认添加一条
      if (!ereaList.length) {
        this.ereaList.push({})
      } else {
        this.ereaList = [...ereaList]
      }
    },
    addErea() {
      this.ereaList.push({})
    },
    onDelete(index) {
      this.ereaList.splice(index, 1)
    },
    onChangeErea() {
      // const checkedNodes = this.$refs[`${type}${index}`][0].getCheckedNodes()
      // if (checkedNodes.length) {
      //   const codeList = [];
      //   checkedNodes.forEach((item) => {
      //     if (item.pathLabels.length > 1 && !item.hasChildren) {
      //       const { parent } = item;
      //       codeList.push({
      //         province: parent?.parent?.label || '',
      //         provinceCode: parent?.parent?.value || '',
      //         city: parent?.label || '',
      //         cityCode: parent?.value || '',
      //         area: item.label,
      //         areaCode: item.value,
      //       });
      //     }
      //   });
      // }
    },
    getCityCode(list) {
      const returnList = []
      list.forEach(item => {
        returnList.push(item.join('/'))
      })
      return returnList
    },
    getSameCity(startList, endList) {
      const startArea = this.getCityCode(startList)
      const endArea = this.getCityCode(endList)
      let same = true
      startArea.forEach(item => {
        if (!endArea.includes(item)) {
          same = false
        }
      })
      return same
    },
    onSubmit() {
      let isAll = false
      let isSame = false
      this.ereaList.forEach(item => {
        // eslint-disable-next-line no-param-reassign
          item.startArea = item.startArea||[];
          // eslint-disable-next-line no-param-reassign
          item.endArea = item.endArea||[];
        if (!item.startArea?.length && !item.endArea?.length) {
          isAll = true
        } else if (item.startArea?.length === item.endArea?.length) {
          const same = this.getSameCity(item.startArea, item.endArea)
          if (same) {
            isSame = true
          }
        }
      })
      if (isAll) {
        this.$message.warning('同一条区域的起始+终止地区不允许都为“所有”')
        return
      }
      if (isSame) {
        this.$message.warning('不允许存在起始地+目的地完全相同的区域')
        return
      }
      this.$emit('changeErea', this.ereaList)
      this.onClose()
    },
    onClose() {
      this.visible = false
      this.ereaList = []
    },
  }
}
</script>

<style lang="less" scoped>
.station-drawer {
  /deep/ .ant-drawer-body {
    height: calc(100% - 125px);
    overflow-y: auto;
  }
  .block {
    margin-bottom: 24px;
  }
  .delete-icon {
    color: #404B5C;
    cursor: pointer;
    flex: 1;
    text-align: right;
  }
  .erea-container {
    background: #F5F5F6;
    border-radius: 4px;
    padding: 16px;
    /deep/ .ant-timeline-item {
      padding-bottom: 24px;
      .ant-timeline-item-tail {
        border-left: 1px solid #D9DBDE;
        top: 20px;
        height: calc(100% - 30px);
      }
      .ant-timeline-item-content {
        min-height: 0;
      }
      &.ant-timeline-item-last {
        padding-bottom: 0;
        .ant-timeline-item-head-blue {
          border-color: #808792;
        }
      }
    }
    .erea-title {
      color: #404B5C;
      line-height: 22px;
      margin-bottom: 8px;
    }
  }
  .add-btn {
    border: 1px dashed #D9DBDE;
    border-radius: 4px;
    /deep/ .ant-btn {
      height: 32px;
      color: #000F25;
      font-weight: 500;
    }
  }
  .drawer-bottom {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    text-align: right;
    padding: 20px 24px;
  }
}
</style>